import { bondAnalyserGaEventsName } from '@helpers/ga-events-name-enum';
import { triggerCustomGaEvent } from '@helpers/miscelleanous';
import { Image, Text } from '@ui/atoms';
import { useRouter } from 'next/router';
import React from 'react';

const features = [
	{
		icon: '/images/bond-analyser/Tailored-to-the-Indian-Bond-Market.svg',
		title: 'Tailored to the <br class="xl:block hidden"/> Indian Bond Market',
		description:
			'Stay updated with current market trends and how they might impact your bond investments.',
	},
	{
		icon: '/images/bond-analyser/Backed-by-Market-Data.svg',
		title: 'Backed by <br class="xl:block hidden"/> Market Data',
		description:
			'Compare multiple bonds side-by-side or evaluate bonds against other investment opportunities.',
	},
	{
		icon: '/images/bond-analyser/Interactive-Visual-Analysis.svg',
		title: 'Interactive <br class="xl:block hidden"/> Visual Analysis',
		description:
			'Interactive charts and graphs to visualise bond performance, yield curves.',
	},
	{
		icon: '/images/bond-analyser/Macro-&-Micro.svg',
		title: 'Macro and Micro <br class="xl:block hidden"/> Analytics',
		description:
			'Cover the entire spectrum from broad market trends to specific bond insights.',
	},
];

const CrackingTheBondCode = () => {
	const router = useRouter();
	return (
		<section className="w-full pb-[60px] pt-10 xl:py-20 px-4 xl:px-12 relative">
			<div className="w-full mx-auto flex flex-col items-center">
				<h2 className="h3-semibold xl:h1-semibold text- mb-4 xl:mb-2 bg-gradient-to-r self-start text-bond-analyser-craking-the-code bg-clip-text text-transparent">
					Cracking the Bond Code
				</h2>
				<p className="h5-regular xl:h3-regular text-primary-500 self-start mb-10 xl:mb-8 font-medium">
					Smart Insights, Smarter Decisions
				</p>
				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 w-full mb-10 relative z-20">
					{features.map((feature, idx) => (
						<div
							key={idx}
							className="flex flex-col items-start rounded-2xl xl:p-6 h-full xl:min-h-[220px]"
						>
							<Image
								src={feature.icon}
								alt={feature.title}
								className="w-8 h-8 xl:w-10 xl:h-10 mb-4"
							/>
							<Text
								content={feature.title}
								htmlTag="h3"
								className="h4-semibold mb-2 text-gray-900"
								isInnerHtml
							/>
							<p className="text-gray-500 p4-medium opacity-80">
								{feature.description}
							</p>
						</div>
					))}
				</div>
				<button
					className="px-6 py-3 relative z-100 explore-our-bond-analyser-suite-button rounded-full text-white font-medium shadow self-start transition-all cursor-pointer"
					onClick={() => {
						triggerCustomGaEvent(bondAnalyserGaEventsName.BA_CLICKED_EXPLORE_BONDINTRO);
						router.push('/bond-analyser/categories');
					}}
				>
					Explore our Bond Analyser Suite
				</button>
			</div>

			<Image
				src="/images/bond-analyser/cracking-the-bond-code-ellipse-bg.svg"
				alt="Cracking the Bond Code"
				className="absolute bottom-0 left-0 z-10 opacity-10"
			/>
		</section>
	);
};

export default CrackingTheBondCode;